import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';

import ManageProgramContext from '../ManageProgramContext';
import WorkoutContext from '../WorkoutContext';

const SecondaryContextsReadyContext = React.createContext();

const SecondaryContextsReadyContextProvider = ({ children }) => {
  const [readyForRemainingContexts, setReadyForRemainingContexts] = useState(false);

  const { isReady: isManageProgramReady } = useContext(ManageProgramContext);
  const { isReady: isWorkoutReady } = useContext(WorkoutContext);

  const areSecondaryContextsReady = useMemo(() => isManageProgramReady && isWorkoutReady, [
    isManageProgramReady,
    isWorkoutReady,
  ]);

  /**
   * Secondary contexts' ready states may change after the initial render. So we need to
   * make sure that the remaining deferred contexts are only initialized once when the
   * secondary contexts are ready the first time, and doesn't get re-initialized again.
   */
  useEffect(() => {
    if (areSecondaryContextsReady && !readyForRemainingContexts) {
      setReadyForRemainingContexts(true);
    }
  }, [areSecondaryContextsReady, readyForRemainingContexts]);

  return (
    <SecondaryContextsReadyContext.Provider value={{ readyForRemainingContexts }}>
      {children}
    </SecondaryContextsReadyContext.Provider>
  );
};

SecondaryContextsReadyContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SecondaryContextsReadyContext;
export {
  SecondaryContextsReadyContextProvider,
};
